// The left dock. A thin region orchestrator: it reads the active activity view
// from the store and renders the Explorer (project tree) or Search. Settings is
// a modal handled elsewhere, so the dock stays on Explorer for it. Parameterless
// the App composes it without props, every child binds to the store directly.

import type { JSX } from "react";
import { useIde } from "../store";
import { Explorer } from "./Explorer";
import { Search } from "./Search";
import "./sidebar.css";

export function Sidebar(): JSX.Element {
  const activityView = useIde((s) => s.activityView);

  if (activityView === "search") return <Search />;
  return <Explorer />;
}
